/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { calculationsControllerBuildingHull } from '../fn/calculations-controller/calculations-controller-building-hull';
import { CalculationsControllerBuildingHull$Params } from '../fn/calculations-controller/calculations-controller-building-hull';
import { calculationsControllerConsumption } from '../fn/calculations-controller/calculations-controller-consumption';
import { CalculationsControllerConsumption$Params } from '../fn/calculations-controller/calculations-controller-consumption';
import { calculationsControllerCustomValue } from '../fn/calculations-controller/calculations-controller-custom-value';
import { CalculationsControllerCustomValue$Params } from '../fn/calculations-controller/calculations-controller-custom-value';
import { calculationsControllerEnergyCertificate } from '../fn/calculations-controller/calculations-controller-energy-certificate';
import { CalculationsControllerEnergyCertificate$Params } from '../fn/calculations-controller/calculations-controller-energy-certificate';
import { calculationsControllerGegEvaluation } from '../fn/calculations-controller/calculations-controller-geg-evaluation';
import { CalculationsControllerGegEvaluation$Params } from '../fn/calculations-controller/calculations-controller-geg-evaluation';
import { calculationsControllerInstallation } from '../fn/calculations-controller/calculations-controller-installation';
import { CalculationsControllerInstallation$Params } from '../fn/calculations-controller/calculations-controller-installation';
import { calculationsControllerLivingArea } from '../fn/calculations-controller/calculations-controller-living-area';
import { CalculationsControllerLivingArea$Params } from '../fn/calculations-controller/calculations-controller-living-area';
import { calculationsControllerPartialHeatLoads } from '../fn/calculations-controller/calculations-controller-partial-heat-loads';
import { CalculationsControllerPartialHeatLoads$Params } from '../fn/calculations-controller/calculations-controller-partial-heat-loads';
import { calculationsControllerSelect } from '../fn/calculations-controller/calculations-controller-select';
import { CalculationsControllerSelect$Params } from '../fn/calculations-controller/calculations-controller-select';
import { GegEvaluationResponse } from '../models/geg-evaluation-response';
import { HeatLoadByBuildingHullResponse } from '../models/heat-load-by-building-hull-response';
import { HeatLoadByConsumptionResponse } from '../models/heat-load-by-consumption-response';
import { HeatLoadByCustomValueResponse } from '../models/heat-load-by-custom-value-response';
import { HeatLoadByEnergyCertResponse } from '../models/heat-load-by-energy-cert-response';
import { HeatLoadByInstallationResponse } from '../models/heat-load-by-installation-response';
import { HeatLoadByLivingAreaResponse } from '../models/heat-load-by-living-area-response';
import { HeatLoadSelectResponse } from '../models/heat-load-select-response';
import { PartialHeatLoadsResponse } from '../models/partial-heat-loads-response';


/**
 * Represents a special API resource for heat load calculations only.
 */
@Injectable({ providedIn: 'root' })
export class CalculationsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `calculationsControllerSelect()` */
  static readonly CalculationsControllerSelectPath = '/planning-projects/v1/calculations/heat-load/select';

  /**
   * Use this action to select a given heat load calculation method as active one and
   *         transfer related calculation input data from ViGuide Planning application-specific section into a project.
   *         <p>Please be aware of additional changes made by the API under the hood. After selection,
   *         the new selected method data located in the `viguidePlanningSpecificData.heatLoadCalculationsData` section
   *         are applied over to the project model data. All related data are overridden.</p>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerSelect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerSelect$Response(params: CalculationsControllerSelect$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadSelectResponse>> {
    return calculationsControllerSelect(this.http, this.rootUrl, params, context);
  }

  /**
   * Use this action to select a given heat load calculation method as active one and
   *         transfer related calculation input data from ViGuide Planning application-specific section into a project.
   *         <p>Please be aware of additional changes made by the API under the hood. After selection,
   *         the new selected method data located in the `viguidePlanningSpecificData.heatLoadCalculationsData` section
   *         are applied over to the project model data. All related data are overridden.</p>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerSelect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerSelect(params: CalculationsControllerSelect$Params, context?: HttpContext): Observable<HeatLoadSelectResponse> {
    return this.calculationsControllerSelect$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadSelectResponse>): HeatLoadSelectResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerEnergyCertificate()` */
  static readonly CalculationsControllerEnergyCertificatePath = '/planning-projects/v1/calculations/heat-load/energy-certificate';

  /**
   * Calculates heat load using Energy Certificate method.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerEnergyCertificate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerEnergyCertificate$Response(params: CalculationsControllerEnergyCertificate$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByEnergyCertResponse>> {
    return calculationsControllerEnergyCertificate(this.http, this.rootUrl, params, context);
  }

  /**
   * Calculates heat load using Energy Certificate method.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerEnergyCertificate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerEnergyCertificate(params: CalculationsControllerEnergyCertificate$Params, context?: HttpContext): Observable<HeatLoadByEnergyCertResponse> {
    return this.calculationsControllerEnergyCertificate$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadByEnergyCertResponse>): HeatLoadByEnergyCertResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerLivingArea()` */
  static readonly CalculationsControllerLivingAreaPath = '/planning-projects/v1/calculations/heat-load/living-area';

  /**
   * Defines a request body used to calculate heating load using Living Area method.<hr><h2>Request variants</h2><p><strong>NewBuilding</strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "NEW_BUILDING",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"energyStandard": "KFW55",<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108"<br>}</code></p><p><strong>NewBuilding with optional <i>buildingPlacement</i></strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "NEW_BUILDING",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"energyStandard": "KFW55",<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingPlacement": "CORNER",<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108"<br>}</code></p><p><strong>Modernization</strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "MODERNISATION",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108",<br>&nbsp;&nbsp;&nbsp;&nbsp;"ventilationHeatRecovery": true,<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingConstructionYear": 1998,<br>&nbsp;&nbsp;&nbsp;&nbsp;"roofModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"wallsModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"windowsModernizationYear": 2008<br>}</code></p><p><strong>Modernization with optional <i>buildingPlacement</i></strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "MODERNISATION",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108",<br>&nbsp;&nbsp;&nbsp;&nbsp;"ventilationHeatRecovery": true,<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingConstructionYear": 1998,<br>&nbsp;&nbsp;&nbsp;&nbsp;"roofModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"wallsModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"windowsModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingPlacement": "CORNER"<br>}</code></p>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerLivingArea()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerLivingArea$Response(params: CalculationsControllerLivingArea$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByLivingAreaResponse>> {
    return calculationsControllerLivingArea(this.http, this.rootUrl, params, context);
  }

  /**
   * Defines a request body used to calculate heating load using Living Area method.<hr><h2>Request variants</h2><p><strong>NewBuilding</strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "NEW_BUILDING",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"energyStandard": "KFW55",<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108"<br>}</code></p><p><strong>NewBuilding with optional <i>buildingPlacement</i></strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "NEW_BUILDING",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"energyStandard": "KFW55",<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingPlacement": "CORNER",<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108"<br>}</code></p><p><strong>Modernization</strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "MODERNISATION",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108",<br>&nbsp;&nbsp;&nbsp;&nbsp;"ventilationHeatRecovery": true,<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingConstructionYear": 1998,<br>&nbsp;&nbsp;&nbsp;&nbsp;"roofModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"wallsModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"windowsModernizationYear": 2008<br>}</code></p><p><strong>Modernization with optional <i>buildingPlacement</i></strong><br><code>{<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectType": "MODERNISATION",<br>&nbsp;&nbsp;&nbsp;&nbsp;"livingArea": 220,<br>&nbsp;&nbsp;&nbsp;&nbsp;"projectCreationYear": 2020,<br>&nbsp;&nbsp;&nbsp;&nbsp;"numberOfPersons": 5,<br>&nbsp;&nbsp;&nbsp;&nbsp;"countryCode": "DE",<br>&nbsp;&nbsp;&nbsp;&nbsp;"postalCode": "35108",<br>&nbsp;&nbsp;&nbsp;&nbsp;"ventilationHeatRecovery": true,<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingConstructionYear": 1998,<br>&nbsp;&nbsp;&nbsp;&nbsp;"roofModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"wallsModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"windowsModernizationYear": 2008,<br>&nbsp;&nbsp;&nbsp;&nbsp;"buildingPlacement": "CORNER"<br>}</code></p>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerLivingArea$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerLivingArea(params: CalculationsControllerLivingArea$Params, context?: HttpContext): Observable<HeatLoadByLivingAreaResponse> {
    return this.calculationsControllerLivingArea$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadByLivingAreaResponse>): HeatLoadByLivingAreaResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerBuildingHull()` */
  static readonly CalculationsControllerBuildingHullPath = '/planning-projects/v1/calculations/heat-load/building-hull';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerBuildingHull()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerBuildingHull$Response(params: CalculationsControllerBuildingHull$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByBuildingHullResponse>> {
    return calculationsControllerBuildingHull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerBuildingHull$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerBuildingHull(params: CalculationsControllerBuildingHull$Params, context?: HttpContext): Observable<HeatLoadByBuildingHullResponse> {
    return this.calculationsControllerBuildingHull$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadByBuildingHullResponse>): HeatLoadByBuildingHullResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerConsumption()` */
  static readonly CalculationsControllerConsumptionPath = '/planning-projects/v1/calculations/heat-load/consumption';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerConsumption()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerConsumption$Response(params: CalculationsControllerConsumption$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByConsumptionResponse>> {
    return calculationsControllerConsumption(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerConsumption$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerConsumption(params: CalculationsControllerConsumption$Params, context?: HttpContext): Observable<HeatLoadByConsumptionResponse> {
    return this.calculationsControllerConsumption$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadByConsumptionResponse>): HeatLoadByConsumptionResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerCustomValue()` */
  static readonly CalculationsControllerCustomValuePath = '/planning-projects/v1/calculations/heat-load/custom-value';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerCustomValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomValue$Response(params: CalculationsControllerCustomValue$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByCustomValueResponse>> {
    return calculationsControllerCustomValue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerCustomValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerCustomValue(params: CalculationsControllerCustomValue$Params, context?: HttpContext): Observable<HeatLoadByCustomValueResponse> {
    return this.calculationsControllerCustomValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadByCustomValueResponse>): HeatLoadByCustomValueResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerInstallation()` */
  static readonly CalculationsControllerInstallationPath = '/planning-projects/v1/calculations/heat-load/installation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerInstallation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerInstallation$Response(params: CalculationsControllerInstallation$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByInstallationResponse>> {
    return calculationsControllerInstallation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerInstallation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerInstallation(params: CalculationsControllerInstallation$Params, context?: HttpContext): Observable<HeatLoadByInstallationResponse> {
    return this.calculationsControllerInstallation$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeatLoadByInstallationResponse>): HeatLoadByInstallationResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerPartialHeatLoads()` */
  static readonly CalculationsControllerPartialHeatLoadsPath = '/planning-projects/v1/calculations/partial-heat-loads';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerPartialHeatLoads()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerPartialHeatLoads$Response(params: CalculationsControllerPartialHeatLoads$Params, context?: HttpContext): Observable<StrictHttpResponse<PartialHeatLoadsResponse>> {
    return calculationsControllerPartialHeatLoads(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerPartialHeatLoads$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerPartialHeatLoads(params: CalculationsControllerPartialHeatLoads$Params, context?: HttpContext): Observable<PartialHeatLoadsResponse> {
    return this.calculationsControllerPartialHeatLoads$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartialHeatLoadsResponse>): PartialHeatLoadsResponse => r.body)
    );
  }

  /** Path part for operation `calculationsControllerGegEvaluation()` */
  static readonly CalculationsControllerGegEvaluationPath = '/planning-projects/v1/calculations/geg-evaluation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationsControllerGegEvaluation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerGegEvaluation$Response(params: CalculationsControllerGegEvaluation$Params, context?: HttpContext): Observable<StrictHttpResponse<GegEvaluationResponse>> {
    return calculationsControllerGegEvaluation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationsControllerGegEvaluation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationsControllerGegEvaluation(params: CalculationsControllerGegEvaluation$Params, context?: HttpContext): Observable<GegEvaluationResponse> {
    return this.calculationsControllerGegEvaluation$Response(params, context).pipe(
      map((r: StrictHttpResponse<GegEvaluationResponse>): GegEvaluationResponse => r.body)
    );
  }

}
